import Utils from '../Utility/Utility'
/* --------------------------------------------------- */
/* -------------- DEFAULT AUTHORS SCRIPT-------------- */
/* --------------------------------------------------- */

var AUTH_POSTS_PER_PAGE = 20;
var AWAY_MAX = 8;

var total_pages_author = 0;
var local_author_year_data = [];

function authors_init(){
    
    $(document).ready(function() {
        initAuthorArchives();
    });
    
}

function initAuthorArchives(){

    //BUILDS DIRECTORY PATH OF CURRENT LOCATION
    var dir = location.pathname.substring(0,location.pathname.lastIndexOf('/')+1);
    var archives_dir = dir + "archives/";

    register_yearly_event();
    

    var this_year = new Date().getFullYear();
    var first_run = true;

    //empty choices preset for seo purposes
    $('select#form_year_select').html('');

    for(var y = this_year; y >= 2008; y--) {

        var year_archive_loc = archives_dir+y+'.js?v='+Math.floor(Date.now() / 300000);

        if(doesFileExist(year_archive_loc)) {

            var year_option = '<option id="archives_link_'+y+'" value="'+year_archive_loc+'">'+y+'</option>';
            $('select#form_year_select').append(year_option);
            if(first_run) {
                loadAuthorJSON_file(year_archive_loc);
                first_run = false;

            }
        }
    }
    
}

function register_yearly_event(){
    $('select#form_year_select').change(function(){
        loadAuthorJSON_file(this.value);
    });
}

function doesFileExist(file_loc) {

    var http = new XMLHttpRequest();
    http.open('HEAD', file_loc, false);
    http.send();
    return http.status!=404 && http.status!=403;
}

function loadAuthorJSON_file(file_loc){

    $(".author-archive .posts ul").css("opacity","0.3");
    $(".processing_div").css("display","block");

    $.getJSON(file_loc, function(data) {

        data.sort(mycomparator); //SORTS JSON RESULTS BY DATE
        local_author_year_data = data;

        show_author_posts(data);
    });
}

function show_author_posts(data, active_page) {

    if(typeof active_page === 'undefined') {
        active_page = 1;
    }

    $('.author-archive .posts ul').html('');

    var article_items = [];

    var total_items = data.length;
    total_pages_author = Math.ceil(total_items / AUTH_POSTS_PER_PAGE);

    for(var i = 0; i < total_items; i++) {

        //BUILDS ITEM REQUESTED CONTAINER
        if(i >= ((active_page - 1) * AUTH_POSTS_PER_PAGE) + AUTH_POSTS_PER_PAGE ) {
            //
        } else if(i >= (active_page - 1) * AUTH_POSTS_PER_PAGE) {

            if( data[i].id != "100495653" ) { // custom filter
                article_items.push(buildAuthor_items(data[i]));	//BUILDS HTML FOR EACH ITEM
            }

            if( data[i].id == "200495585" ) {
                article_items.push(buildAuthor_items(
                    {
                        "id": "200137300",
                        "title": "Bahrain&acute;s Hezbollah Problem Is America&acute;s Problem Too",
                        "href": "https://www.realclearpolitics.com/articles/2018/06/20/bahrains_hezbollah_problem_is_americas_problem_too.html",
                        "pub_name": "shaikh_abdullah_bin_rashid_al_khalifa",
                        "art_date": "1529470800",
                        "excerpt": "Bahrain is the America&rsquo;s oldest ally in the Middle East. Our relationship has grown and deepened for more than a century. The global war on terrorism has only strengthened...",
                        "img_url": "https://assets.realclear.com/images/45/452201_1_.jpg",
                        "type": "200"
                    }
                ));
            }

            if( data[i].id == "200137300" ) {
                article_items.push(buildAuthor_items(
                    {
                        "id": "200495585",
                        "title": "Innovating for Responsible Governance During COVID",
                        "href": "https:\/\/www.realclearworld.com\/articles\/2020\/06\/08\/innovating_for_responsible_governance_during_covid_495585.html",
                        "pub_name": "abdulla_bin_rashid_al_khalifa",
                        "art_date": 1591592400,
                        "excerpt": "Global Responsibility&nbsp;&nbsp;\nIn this unprecedented time of global concern and uncertainty, solace may be taken in the stalwart resilience of mankind...responsible mankind.&nbsp;...",
                        "img_url": null,
                        "type": 200
                    }
                ));
            }
        }
    }
    if(total_items > AUTH_POSTS_PER_PAGE) {
        create_author_pagination(total_pages_author, active_page);
    } else {
        $('.author-archive .pagination_container').remove();
    }

    //INSERTS INTO TO UL LISTING																
    $('.author-archive .posts ul').html(article_items.join('')); //INSERTS INTO HTML
    $(".author-archive .posts ul").css("opacity","1");
    $(".processing_div").css("display","none");
}

function create_author_pagination(total_pages, active_page) {

    if(typeof active_page === 'undefined') {
        active_page = 1;
    } else {
        active_page = parseInt(active_page);
    }
    var html = '';

    html += '<div class="pagination_container xsmall">';
    html += '<div class="pagination">';
    html += '<ul>';

    var prev_page = 1;
    if(active_page > 2) {
        prev_page = active_page - 1;
    }

    var next_page = total_pages;
    if(active_page < total_pages - 1) {
        next_page = active_page + 1;
    }

    html += '<li><a data-page="'+prev_page+'"></a></li>';

    var active_class = '';
    var away_class = 'away_far';
    var aways = 0;
    for(var i = 1; i <= total_pages; i++) {

        active_class = '';
        away_class = 'away_far';

        if(i == active_page) {
            active_class = 'active';
            away_class = '';
        } else if(i < active_page + 4 && i > active_page - 4 && aways < AWAY_MAX) {

            aways++;
            away_class = 'away_'+(aways);
        }
        html += '<li class="'+active_class+' '+away_class+'"><a data-page="'+i+'">'+i+'</a></li>';
    }

    html += '<li><a data-page="'+next_page+'"></a></li>';

    html += '</ul>';
    html += '</div>';
    html += '</div>';

    $('.author-archive .pagination_container').remove();
    $('.author-archive .posts').after(html);

    $('.author-archive .pagination_container .pagination ul li a').click(function(e) {

        e.preventDefault();

        var divPosition = $('.author-top').offset();
        $('html, body').animate({scrollTop: divPosition.top}, "slow");

        var active_page = $(this).attr('data-page');
        show_author_posts(local_author_year_data, active_page);
    });
}

function buildAuthor_items(item){

    var art_item = '<li class="item">';

    if(item.img_url!="" && item.img_url != null){
        if(parseInt(item.type) == 700){
            art_item += '<a class="image" href="'+item.href+'">';
            art_item += '<div class="photo">';
            art_item += '<img class="video lazyload" loading="lazy" src="'+item.img_url+'">';
            art_item += '<img class="icon lazyload" loading="lazy" src="//www.realclearpolitics.com/asset/img/icon-play.png">';
            art_item += '</div>';
            art_item += '</a>';
        }else{
            art_item += '<a class="image" href="'+item.href+'">';
            /*
            * Adding Image webp
            * */
            if(typeof item.img_url_webp !== 'undefined' && item.img_url_webp  != ''){
                art_item += '<div class="photo">';
                    art_item += '<picture>';
                        art_item += '<source srcset="'+ item.img_url_webp +'" type="image/webp" />';
                        art_item += '<img class="lazyload" loading="lazy" srcset="'+ item.img_url +'" type="image/jpg" alt="'+ item.excerpt +'" />';
                    art_item += '</picture>';
                art_item += '</div>';
            }else{
                art_item += '<div class="photo"><img class="lazyload" loading="lazy" src="'+item.img_url+'" type="image/jpg"></div>';
            }
            
            art_item += '</a>';
        }

    }

    art_item += '<div class="date">'+dateFromTimeStamp(item.art_date)+'</div>';
    art_item += '<div class="title"><a href="'+item.href+'">'+item.title+'</a></div>';
    if(typeof item.source !== 'undefined'){
        art_item += '<div class="source">'+item.source+'</a></div>';
    }
    art_item += '<div class="excerpt">'+item.excerpt+'</div>';
    art_item += '</li>';

    return art_item;
}

//SORT JSON RESULTS
// a and be are object elements of your array
function mycomparator(a,b) {
    return parseInt(b.art_date) - parseInt(a.art_date);
}

function dateFromTimeStamp(t) {
    var monthnames = ["January", "February", "March",
        "April", "May", "June", "July",
        "August", "September", "October",
        "November", "December"];
    var date = new Date(t*1000);
    return monthnames[date.getMonth()] + ' ' + date.getDate() + ', ' + date.getFullYear();
}

//checks for testing query string and reloads the page if on www1
function testing() {
    var testing = Utils.get_query_param('testing');
    var preview = Utils.get_query_param('preview');
    if ((testing == null || testing.length == 0) || (preview == null || preview.length == 0)) {
        var url = window.location.host;
        var url_parts = url.split('.');
        if (url_parts[0] == 'www1') {
            var location = window.location.href;
            location = location.replace('www1', 'www');
            window.location = location;
        }
    }
}

testing();
   

export default authors_init;